<template>
    <div v-if="value != null">
        <IconComp
            v-for="(miss, shootingNumber) in value"
            :key="`${shootingNumber}-${miss}`"
            :family="miss ? 'fa-solid' : undefined"
            icon="fa-circle"
            class="me-1"
        />
    </div>
</template>
<script setup lang="ts">
import { IconComp } from '@/components';

defineProps<{
    /**
     * Missed shot array.
     * True are misses, false are hits.
     * Null means we haven't shot yet.
     */
    value: Array<boolean> | null;
}>();
</script>
